import { render, staticRenderFns } from "./gitlavReport.vue?vue&type=template&id=d47243f6&"
import script from "./gitlavReport.vue?vue&type=script&lang=js&"
export * from "./gitlavReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports